import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Button, Spinner } from '@heroui/react';
import { refreshUserDoc, useAuth } from '../../hooks/useAuth';
import { defaultAppRoute } from '../../shell/nav-items';

export default function CustomerCompletedGate({ children }: { children: ReactNode }) {
  const { authUser, userDoc, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  if (!userDoc) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
        <p className="text-muted">Não foi possível carregar seu cadastro no servidor.</p>
        <Button variant="primary" onPress={() => void refreshUserDoc()}>
          Tentar novamente
        </Button>
      </div>
    );
  }

  if (userDoc.customerCompleted || userDoc.isGlobalAdmin) {
    return <Navigate to={defaultAppRoute} replace />;
  }

  return <>{children}</>;
}
